module.exports = __webpack_public_path__ + "static/media/8.24d36456.jpg";